import { fetchAuthSession } from '@aws-amplify/core';
import { Button } from 'features/components/Button';
import { env } from 'features/env';
import { useSelector } from 'hooks/utils';
import { useState } from 'react';
import { toast } from 'react-toastify';

export function Security() {
	const language = useSelector(state => state.ui.i18n.language);

	const translation = DICTIONARY[language];

	const [isCopying, setIsCopying] = useState(false);
	const copyAccessTokenToClipboard = async () => {
		setIsCopying(true);

		try {
			const session = await fetchAuthSession();

			if (!session.tokens?.idToken) {
				throw new Error('No token found');
			}

			navigator.clipboard.writeText(session.tokens.idToken.toString());

			toast.success(translation.copyTokenToClipboard, {
				position: 'top-center'
			});
		} catch (error) {
			toast.error(translation.copyTokenToClipboardError);
			console.error(error);
		} finally {
			setIsCopying(false);
		}
	};

	const copyRefreshTokenToClipboard = async () => {
		setIsCopying(true);

		const userName = localStorage.getItem(
			`CognitoIdentityServiceProvider.${env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID}.LastAuthUser`
		);
		const refreshToken = localStorage.getItem(
			`CognitoIdentityServiceProvider.${env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID}.${userName}.refreshToken`
		);

		if (refreshToken === null) {
			console.error('Refresh token not found in Security.tsx');
			throw new Error('No token found');
		}

		navigator.clipboard.writeText(refreshToken);

		toast.success(translation.copyTokenToClipboard, {
			position: 'top-center'
		});

		setIsCopying(false);
	};

	return (
		<div className="flex flex-row justify-between items-end px-[24px] h-full">
			<Button
				type="button"
				variant="secondary"
				text="Copy access token"
				onClick={copyAccessTokenToClipboard}
				disabled={isCopying}
			/>
			<Button
				type="button"
				variant="secondary"
				text="Copy refresh token"
				onClick={copyRefreshTokenToClipboard}
				disabled={isCopying}
			/>
		</div>
	);
}

const DICTIONARY = {
	EN: {
		copyTokenToClipboard: 'Token copied to clipboard',
		copyTokenToClipboardError: 'Failed to copy token to clipboard'
	},

	NB: {
		copyTokenToClipboard: 'Token kopiert',
		copyTokenToClipboardError: 'Feil ved kopi av token'
	}
} as const;
